var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-view',{attrs:{"styles":(_vm.styles + " rel")}},[_c('b-view',{attrs:{"styles":"abs max bg-none","states":{
                line: {
                    style: ("line line-" + _vm.outlineColor + " thick-" + (_vm.line[1] + 1)),
                    state: _vm.outlineColor
                }
            }}}),_vm._v(" "),_c('b-view',{attrs:{"styles":"grid"}},_vm._l((_vm.colData.items),function(item){return _c('b-view',{key:item.id,class:_vm.colData.common_plan || item.plan,attrs:{"styles":("line-b line-r line-" + (_vm.line[0]) + " thick-" + (_vm.line[1]) + " h-" + _vm.gridHeight + " ")}},[_vm._t(item.id)],2)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53dae859","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/core/b-grid.vue
// module id = null
// module chunks = 